import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KioskCallsComponent } from './kiosk-calls.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [KioskCallsComponent],
  exports: [KioskCallsComponent],
})

export class KioskCallsModule {}
